<template>
  <v-row>
    <v-col class="wrapper-pay">
      <template v-if="pay == 'true'">
        <span class="title-pay sucsess">
          ОПЛАТА ПРОШЛА УСПЕШНО
        </span><br /> 
        <span class="text-pay">
          Мы получили ваш платеж
        </span><br /> 
      </template>
      <template v-if="pay == 'false'">
        <span class="title-pay error-custom">
          ОПЛАТА НЕ ПРОШЛА
        </span><br /> 
        <span class="text-pay">
          Мы не получили ваш платеж
        </span><br /> 
      </template>
      <router-link to="/">
        <button class="red-button">
          Вернуться на главную
        </button>
      </router-link>
    </v-col>
  </v-row>
</template>

<script>

export default {
  data: () => ({
    pay: 'false',
  }),
  methods: {

  },
  mounted() {
    console.log(this.$route.query.pay)
    if(this.$route.query.pay) {
      this.pay = this.$route.query.pay;
    }
  },

};
</script>


<style scoped>
  .wrapper-pay{
      height: calc(100vh - 141px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }
  .title-pay{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 36px;
    
  }
  .sucsess{
    color: green;
  }
  .error-custom{
    color: red;
  }
  .text-pay{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 131.5%;
    
    color: #000000;
  }
</style>


// WEBPACK FOOTER //
// payment.vue?1727cc46